import type { QRL } from "@builder.io/qwik";
import { component$ } from "@builder.io/qwik";
import { cn } from "~/utils/tailwind-helper";

interface NavigationMenuButtonProps {
    class?: string;
    highlightMiddleOpen: boolean;
    mobileSubmenuOpen: boolean;
    transparentMode: boolean;
    toggleMenuLeft$: QRL<() => void>;
    activeHighlightIndex: number;
}

export const NavigationMenuButton = component$<NavigationMenuButtonProps>(
    ({
        class: className,
        highlightMiddleOpen,
        mobileSubmenuOpen,
        toggleMenuLeft$,
        transparentMode,
        activeHighlightIndex,
    }) => {
        // Map for animation delays based on diagonal pattern
        const getDelay = (row: number, col: number) => {
            // Calculate diagonal position (0-4) from top-left to bottom-right
            const diagonalPosition = row + col;
            return `${diagonalPosition * 100}ms`;
        };

        return (
            <button
                onClick$={toggleMenuLeft$}
                type="button"
                class={cn(
                    "group flex h-10 w-10 shrink-0 items-center justify-center rounded-full border",
                    "transition-colors",
                    // "transition-[box-shadow,border-color,background-color] duration-300",
                    // "shadow-sm hover:shadow-md",
                    // transparentMode ? "shadow-primary-500/30" : "shadow-white/25",
                    transparentMode && !mobileSubmenuOpen
                        ? "border-transparent bg-white/10 backdrop-blur-md hover:bg-white/30"
                        : "border-primary-500/5 bg-transparent hover:border-primary-500/10 hover:bg-primary-500/10",
                    className,
                )}
                aria-label="Menu"
            >
                <div class="grid grid-cols-3 gap-[3px]">
                    {[...Array(3)].map((_, rowIndex) =>
                        [...Array(3)].map((_, colIndex) => (
                            <div
                                key={`${rowIndex}-${colIndex}`}
                                style={{
                                    animationDelay: getDelay(rowIndex, colIndex),
                                }}
                                class={cn(
                                    "group-hover:animate-pulse-opacity h-[3px] w-[3px] rounded-full opacity-100 transition-colors duration-300",
                                    transparentMode && !mobileSubmenuOpen && "bg-white",
                                    highlightMiddleOpen || mobileSubmenuOpen
                                        ? "bg-primary-500"
                                        : transparentMode
                                          ? cn("bg-white", activeHighlightIndex !== -1 && "delay-200")
                                          : "bg-primary-500",
                                )}
                            />
                        )),
                    )}
                </div>
            </button>
        );
    },
);
